
var bf = {
    root: false,
    automaticBrowserDarkmode: false,
    skippableContents: [
        // { selector: '.fbmaps--map--wrap', title: 'Karte', skipped: false },
    ],
    currentSkipElement: null,
    firstTabPressed: false,

    callbacks: {
        fontSizeChange : false,
        contrastChange : false
    },
    init: function () {
        this.root = document.documentElement;
        var initlevel = parseInt(localStorage.getItem('bf_text_level'));
        if(typeof initlevel == 'undefined') this.text.init(); // get default level if not in storage
        this.bindHandlers();
        this.tabNav.init();
        // this.text.init();
        // this.audio.init();
        this.createSkipButton();
        // this.createContentSkipButton();
        this.handleTabPress();
        this.monitorFocus();
        this.sonstiges();

        // create events for optional callbacks
        for (const cb in bf.callbacks) {
            bf.callbacks[cb] = new Event('bf_'+cb);
        }

        if (typeof initlevel !== 'undefined' && !isNaN(initlevel)) {
            bf.text.current = initlevel;
            bf.text.update();
        }
        
        
        var initcontrast = localStorage.getItem('bf_contrast');

        if(this.automaticBrowserDarkmode) {
            // browser automatically sets darkmode if prefers-color-scheme is set to dark
            if ((initcontrast == 1 || (window.matchMedia("(prefers-color-scheme: dark)").matches && initcontrast == null)) && !this.contrast.active) this.contrast.toggle();
        } else {
            if(initcontrast == 1 && !this.contrast.active) this.contrast.toggle();
        }
    },
    bindHandlers: function () {
        if(document.querySelector('.fonttool--standard')) {
                document.querySelector('.fonttool--standard').addEventListener('click', function (e) {
                e.preventDefault();
                bf.text.reset();
            }); 
        }
        if(document.querySelector('.fonttool--plus')) {
                document.querySelector('.fonttool--plus').addEventListener('click', function (e) {
                e.preventDefault();
                bf.text.incr();
            });       
        }
        if(document.querySelector('.fonttool--minus')) {
                document.querySelector('.fonttool--minus').addEventListener('click', function (e) {
                e.preventDefault();
                bf.text.decr();
            });       
        }
        if(document.querySelector('.fonttool--reset')) {
                document.querySelector('.fonttool--reset').addEventListener('click', function (e) {
                e.preventDefault();
                bf.text.reset();
            });
        }
        if(document.querySelector('.fonttool--contrast')) {
                document.querySelector('.fonttool--contrast').addEventListener('click', function (e) {
                e.preventDefault();
                bf.contrast.toggle();
            });
        }

         // swiper nav buttons
        var swiper = document.querySelector('.swiper-button-prev');
        if(swiper) {
            document.querySelector('.swiper-button-prev').addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault(); // verhindert Scrollen bei Space
                    this.click(); // simuliert Klick
                }
            });
            
            document.querySelector('.swiper-button-next').addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.click();
                }
            });
        }

        // owl carousel 
        function updateOwlAccessibility() {
            document.querySelectorAll('.owl-item').forEach(item => {
              const isActive = item.classList.contains('active');
          
              // Set aria-hidden and tabindex for accessibility
              item.setAttribute('aria-hidden', !isActive);
              item.querySelectorAll('a, button, input, [tabindex]').forEach(focusable => {
                focusable.tabIndex = isActive ? 0 : -1;
              });
            });
          }
          
        // Call on load and whenever the carousel changes
        updateOwlAccessibility();
        
        $('.owl-carousel').on('changed.owl.carousel', function() {
            setTimeout(() => {
                updateOwlAccessibility();                
            }, 300);
        });
          

             

        
        setTimeout(() => {
            // if leaflet map exists -> trigger 'enter' on map markers to trigger click event
            var leafletMap = document.querySelector('.leaflet-container');
            
            if(leafletMap) {
                
                var markers = leafletMap.querySelectorAll('.leaflet-marker-icon');
                if(markers) {                    
                    markers.forEach(function(marker){
                        marker.addEventListener('keydown', function(e) {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // verhindert Scrollen bei Space
                                this.click(); // simuliert Klick
                            }
                        });
                    });
                }
            }            
        }, 300);
          
    },
    
    audio: {
        el : false,
        container: false,
        trigger: false,
        addToHeadline: true,
        playing: false,
        init: function() {
            const self = this;
            self.container = document.querySelector('.fbwa-audioreader');
            self.el = self.container.querySelector('.fbwa-audioreader audio');
            self.trigger = document.querySelector('.trigger--vorlesefunktion');
            // if not exists disable trigger and return
            if(!self.el) {  
                if(self.trigger) {
                    self.trigger.classList.add('disabled');
                }
                return; 
            }

            if(self.addToHeadline) {
                self.addHeadlineElement();
            }


            // bind triggers        
            if(self.trigger) {
                self.trigger.addEventListener('click', function (e) {
                    trigger(e);
                });

                if(self.addToHeadline) {                    
                    document.querySelector('.trigger--vorlesefunktion--inline').addEventListener('click', function (e) {
                        trigger(e);
                    });
                }

                function trigger(e){
                    e.preventDefault();
                    self.open();
                    $('.radialwheel--wrap').removeClass('opened');
                    setTimeout(() => {
                        Fancybox.close();			
                    }, 400);
                }
            }
            // add event listeren for click outside of element to close audioplayer
            document.addEventListener('click', function(e){
                if(!self.container.contains(e.target) && e.target != self.trigger  && !e.target.classList.contains('trigger--vorlesefunktion--inline')) {
                    self.close();
                }
            });
            
            // playing class
            self.el.addEventListener('playing',function() { 
                self.container.classList.add('playing'); 
                self.playing = true;
            },false); 
            self.el.addEventListener('pause',function() { 
                self.container.classList.remove('playing'); 
                self.playing = false;
            },false); 
    
        },
        open : function() {
            const self = this;
            if(self.container) {
                self.container.classList.add('init');
                self.container.classList.add('show');
                if(!self.playing) {
                    // focus on audio element
                    self.el.focus();
                    self.start();
                }
            }
        },
        close : function() {
            const self = this;
            if(self.container) {
                self.container.classList.remove('show');                
            }
        },
        start : function() {
            const self = this;
            if(self.el) {
                self.el.play();           
            }
        },
        stop : function() {
            const self = this;
            if(self.el) {
                self.el.pause();             
            }
        },
        getDuration: function() {
            const self = this;
            $audioduration = self.container.querySelector('.audioduration');
            if($audioduration) return $audioduration.innerHTML;
        },
        addHeadlineElement : function() {
            const self = this;
            // add a trigger html element below the first h1 element
            const h1 = document.querySelector('h1');
            if(h1) {               
                title = document.querySelector('.fbwa-audioreader-title').innerHTML;
                if(!title) title = 'Seite vorlesen:';
                const el = document.createElement('a');
                el.classList.add('trigger--vorlesefunktion--inline');
                el.setAttribute('href','#');
                el.innerHTML = title;
                el.innerHTML += ' <span class="audioduration">'+self.getDuration()+'</span>';
                h1.parentNode.insertBefore(el, h1.nextSibling);
            }

        }
    },
    contrast: {
        active: false,
        btn: $('a.fonttool--contrast'),
        toggle: function (reverse) {
            var reverse = (typeof reverse !== 'undefined' ? true : false);
            if (reverse || this.active) {
                // this.reverse();
                this.active = false;
                localStorage.setItem('bf_contrast', 0);
                bf.root.classList.remove('contrast');
                bf.root.removeAttribute('darkmode');
                document.dispatchEvent(bf.callbacks.contrastChange);
                return;
            }
            // loop over colors
            this.active = true;
            localStorage.setItem('bf_contrast', 1);
            bf.root.classList.add('contrast');
            bf.root.setAttribute('darkmode', 'true');
            // this.colors.forEach(function (color) {
            //     bf.contrast.changeColor(color);
            // });
            document.dispatchEvent(bf.callbacks.contrastChange);

            // var stylesheet = $("link[title='fbwa-css']"); 
            // var stylesheetCss = $("meta[name='fbwa-css']")[0].content;
            // var stylesheetCssContrast = $("meta[name='fbwa-css-contrast']")[0].content;

            // if(this.active){
            //     var txt = 'Kontrastmodus aktivieren';
            //     this.active = false;
            //     link = stylesheet[0].href.replace(stylesheetCssContrast,stylesheetCss);
        
            // } else {
            //     var txt = 'Kontrastmodus deaktivieren';
            //     this.active = true;
            //     link = stylesheet[0].href.replace(stylesheetCss,stylesheetCssContrast);
            // }
            
            // this.btn[0].ariaLabel = txt;
            // this.btn[0].dataset.hint = txt;
            // stylesheet[0].href = link;
            // localStorage.setItem('bf_contrast', this.active);

        },
    },
    text: {
        levels: {
            '0': { size: '14px' },
            '1': { size: '15px' },
            '2': { size: '16px' },
            '3': { size: '17px' },
            '4': { size: '18px' },
            '5': { size: '19px' },
            '6': { size: '20px' },
            '7': { size: '21px' },
            '8': { size: '22px' },
            '9': { size: '23px' },
            '10': { size: '24px' },
            '11': { size: '25px' },
            '12': { size: '26px' },
        },
        min: 0,
        max: 12,
        current: 6,
        original : 6,
        init: function () {

            var osize = window.getComputedStyle(bf.root)['font-size'];
            if (osize) {
                for (const l in bf.text.levels) {
                    if (Object.hasOwnProperty.call(bf.text.levels, l)) {
                        if (bf.text.levels[l].size == osize) {
                            bf.text.original = parseInt(l);
                            bf.text.current = parseInt(l);
                        }
                    }
                }
            }
            
        },
        reset: function(){
            bf.root.style = '';
            bf.utility.removeClassByPrefix(bf.root, 'fonttool--level--');
            localStorage.removeItem('bf_text_level');
            bf.text.current = bf.text.original;
        },
        incr: function () {
            if (this.levels[this.current + 1]) {
                this.current = this.current + 1;
                this.update();
            }
        },
        decr: function () {
            if (this.levels[this.current + -1]) {
                this.current = this.current + -1;
                this.update();
            }
        },
        update: function () {
            if (this.levels[this.current] && this.levels[this.current].size) {
                // bf.root.css("fontSize", this.levels[this.current].size);
                bf.root.style.fontSize = this.levels[this.current].size;
            }
            if (this.current == this.min) {
                bf.root.classList.add('fonttool--min');
            } else {
                bf.root.classList.remove('fonttool--min');
            }
            if (this.current == this.max) {
                bf.root.classList.add('fonttool--max');
            } else {
                bf.root.classList.remove('fonttool--max');
            }
            bf.utility.removeClassByPrefix(bf.root, 'fonttool--level--');
            bf.root.classList.add('fonttool--level--'+this.current);
            // save to local Storage
            localStorage.setItem('bf_text_level', this.current);
            document.dispatchEvent(bf.callbacks.fontSizeChange);
        }
    },
    tabNav : {
        ping : false,
        init : function() {
            this.createPing();
            this.bindHandlers();            
            this.addSequence();
        },
        bindHandlers : function() {
            document.addEventListener('keyup',function(e){
                if( e.code == 'Tab' || e.which == 9) {
                    bf.tabNav.ping.classList.remove('pinging');
                    bf.tabNav.executePing(e.target);

                    // body add Class 'keyboard-nav'
                    if(!document.body.classList.contains('keyboard-nav')) {
                        document.body.classList.add('keyboard-nav');
                    }

                    
                    var focus = document.querySelector('.focus');
                    if(focus) {
                        if(!focus.contains(e.target)) focus.classList.remove('focus');
                    }
                }
            });   
            
            // 'Enter' on '.openSubmenu' to focus first li a in following ul
            document.querySelectorAll('.openSubmenu').forEach(function(el){
                el.addEventListener('keydown', function(e){
                    if(e.keyCode == 13) {
                        e.preventDefault();
                                               
                        var target = e.target.nextSibling.querySelector('li > a.dropdown-item');
                        
                        if(target) {
                            target.focus();
                            // then remove all tabindex from all other links in the same ul
                            var $parent = $(target).parent();
                            var $siblings = $parent.parent('ul').find('li > a.dropdown-item');
                            if($siblings) {
                                $siblings.each(function() {
                                    this.removeAttribute('tabindex');
                                });
                            }
                        }
                    }
                });
            });

            
            document.addEventListener("keydown", function(e) {
                // Listen for the up, down, left and right arrow keys, otherwise, end here, with e.code
                if ([37,38,39,40,27].indexOf(e.keyCode) == -1) {
                    return;
                }

                // Store the reference to our top level link
                var link = document.querySelector('.nav-item:focus-within');

                if(link) { // TODO: jquery entfernen? & weiter testen
                    var target = link.querySelector('a:focus');
                    var $parent = $(target).parent();
                    e.preventDefault();
                    switch(e.keyCode) {
                        case 27: // ESC
                            $('ul.navbar-nav > .nav-item.active > .nav-link').focus();
                            break;
                        case 37: // left arrow
                            if($(target).closest('ul').prev('a.dropdown-item').length) {
                                $(target).closest('ul').prev('a.dropdown-item').first().focus();
                            }
                            break;
                        case 38: /// up arrow
                            if($parent.prev('li.nav-item').not('.nav-parent-wrap').length) {
                                $parent.prev('li.nav-item').not('.nav-parent-wrap').find('a.dropdown-item').first().focus();
                            } else {
                                $parent.parent('ul').prev('a.dropdown-item').first().focus();
                            }
                            break;
                        case 39: // right arrow
                            if($(target).nextAll('ul').length) {
                                $(target).nextAll('ul').find('li.nav-item a.dropdown-item').first().focus();
                            }
                            break;
                        case 40: // down arrow
                            if($(target).nextAll('ul').length) {
                                $(target).nextAll('ul').find('li.nav-item a.dropdown-item').first().focus();
                            } else {
                                if($parent.next('li.nav-item').length) {
                                    $parent.next('li.nav-item').find('a.dropdown-item').first().focus();
                                } else {
                                    $parent.closest('ul').parent().next('li.nav-item').find('a.dropdown-item').first().focus();
                                }
                            }
                            break;
                    }                        
                }
            });
        },
        addSequence : function() {
            var lastindex = 1;

            // reihenfolge für tab nav festlegen 
            // var stoererRight = document.querySelector('.stoerer-right');
            // if(stoererRight && document.querySelector('.stoerer-right .frame')) stoererRight.tabIndex = lastindex++;

            // var stoererLeft = document.querySelector('.stoerer-left');
            // if(stoererLeft && document.querySelector('.stoerer-left .frame')) stoererLeft.tabIndex = lastindex++;

            // var logos = document.querySelectorAll('.navbar-brand-image');
            // if(logos) {
            //     logos.forEach(function(logo){
            //         logo.tabIndex = lastindex++;
            //     });
            // }

            // disable tabbing here 
            var welcomeSliderLinks = document.querySelectorAll('.backendlayout-welcome .gallery-header a, .backendlayout-welcome .gallery-header button');
            if(welcomeSliderLinks) {
                welcomeSliderLinks.forEach(function(wsl){
                    wsl.tabIndex = -1;
                });
            }

            var navitems = document.querySelectorAll('.dropdown-menu.menu-level-3 .nav-item > a');
            if(navitems) {
                navitems.forEach(function(navitem){
                    navitem.tabIndex = -1;
                });
            }
        },
        createPing : function() {
            this.ping = document.createElement('div');
            this.ping.setAttribute('id','ping');
            document.body.append(this.ping);
        },
        executePing : function(target) {
            var pos = target.getBoundingClientRect();
            this.ping.style.top = pos.top + (pos.height / 2) + 'px';
            this.ping.style.left = pos.left + (pos.width / 2) + 'px';
            this.ping.classList.add('pinging');
        }
    },
    utility : {
        removeClassByPrefix : function(node, prefix) {
            var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
            node.className = node.className.replace(regx, '');
            return node;
        }
    },
    // Erstes Tab-Erlebnis: Direkter Sprung zum Hauptinhalt
    createSkipButton: function () {
        this.skipButton = document.createElement("button");
        this.skipButton.textContent = "Direkt zum Inhalt springen";
        this.skipButton.setAttribute("href", "#wrapper");
        Object.assign(this.skipButton.style, {
            position: "absolute",
            top: "10px",
            left: "10px",
            padding: "10px",
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            display: "none",
            zIndex: "9999"
        });

        document.body.prepend(this.skipButton);

        this.skipButton.addEventListener("click", (e) => {
            e.preventDefault();
            let firstHeading = document.querySelector("#wrapper h1, #wrapper h2");
            if (firstHeading) {
                firstHeading.setAttribute("tabindex", "-1");
                firstHeading.focus();
                firstHeading.scrollIntoView({ behavior: 'smooth' });
            }
            this.skipButton.style.display = "none";
        });

        this.skipButton.addEventListener("blur", () => {
            this.skipButton.style.display = "none";
        });
    },

    // Extra-Skip-Button für überspringbare Inhalte (z.B. Karten, Galerien)
    createContentSkipButton: function () {
        this.contentSkipButton = document.createElement("button");
        this.contentSkipButton.textContent = "Überspringen";
        Object.assign(this.contentSkipButton.style, {
            position: "absolute",
            padding: "10px",
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            display: "none",
            zIndex: "9999"
        });

        document.body.appendChild(this.contentSkipButton);

        this.contentSkipButton.addEventListener("click", (e) => {
            e.preventDefault();
            if (this.currentSkipElement) {
                this.skipElement(this.currentSkipElement);
            }
            this.contentSkipButton.style.display = "none";
        });

        // this.contentSkipButton.addEventListener("blur", () => {
        //     setTimeout(() => {
        //         this.contentSkipButton.style.display = "none";
        //     }, 200);
        // });
    },

    // EventListener für den ersten Tab-Druck
    handleTabPress: function () {

        // nur wenn vorher noch keine interaktion mit der Seite stattfand - wie klick oder so
        // if click -> firstTabPressed = true
        document.addEventListener("click", () => {
            this.firstTabPressed = true;
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Tab" && !this.firstTabPressed) {
                this.firstTabPressed = true;
                this.skipButton.style.display = "block";
                this.skipButton.focus();
                e.preventDefault();
            }
        });
    },

    // Überwachung von Fokus-Wechseln
    monitorFocus: function () {
        document.addEventListener("focusin", (e) => {
            this.skippableContents.forEach((item) => {
                let element = document.querySelector(item.selector);
                if (element && element.contains(e.target)) {
                    this.currentSkipElement = element;
                    this.showContentSkipButton(element, item);
                }
            });
        });
    },

    // Zeigt den Überspringen-Button neben dem aktuellen Element an
    showContentSkipButton: function (element, container) {
        let rect = element.getBoundingClientRect();
        console.log('Element-Position:', rect, container);
        
        this.contentSkipButton.style.top = `${rect.top + window.scrollY + 10}px`;
        this.contentSkipButton.style.left = `${rect.left + window.scrollX + 10}px`;
        this.contentSkipButton.style.display = "block";
        this.contentSkipButton.textContent = "Überspringe " + container.title;
        this.contentSkipButton.dataset.container = container.selector;
        this.contentSkipButton.focus();
    },


   skipElement: function (container) {
        
        // suche nach letzem fokssierbarem element im container
        // focus
        // dann trigger tab keydown event?
        console.log('skipElement', container);

        if (container) {
            let focusableElements = container.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusableElements.length > 0) {
                console.log('Focus:', focusableElements[focusableElements.length - 1]);
                focusableElements[focusableElements.length - 1].focus();
            } else {
                container.focus();
            }
        } else {
            console.error("Container not found:", container);
        }
        // hide button after skipping
        this.contentSkipButton.style.display = "none";
        this.currentSkipElement = null;

    },

    sonstiges: function () {

        // if no 'role="main" -> add role="main"' to wrapper
        var mainElement = document.querySelector('[role="main"]');
        if (!mainElement) {
            var wrapper = document.querySelector('#wrapper');
            if (wrapper) {
                wrapper.setAttribute('role', 'main');
            }
        }



    }
}


